var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 84,
    viewBox: "0 0 96 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1273_1654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2139 0.5H86.5938C88.7448 0.5 90.5214 2.31336 90.5215 4.47949V67.6719C90.5215 68.5055 89.8346 69.1982 89.0117 69.1982C88.1704 69.198 87.5029 68.5485 87.5029 67.7246V67.2246H87.4395V58.7588L86.9004 58.8008C86.8314 58.8062 86.7711 58.8194 86.7266 58.8311C86.6846 58.8421 86.6421 58.8565 86.6201 58.8633C86.5971 58.8704 86.5834 58.8734 86.5771 58.875H12.4492C10.3056 58.8749 8.58203 57.079 8.58203 54.9053V14.7598C8.58219 12.6009 10.2911 10.8907 12.4492 10.8906H52.8418C54.7676 10.8904 56.5058 9.72805 57.3027 7.99121L57.3037 7.99023L59.6611 2.81445C60.3013 1.41934 61.6932 0.5 63.2139 0.5Z",
    fill: "#FFE100",
    stroke: "#92841D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44238 22.3945H82.5859C84.725 22.3945 86.4393 24.2024 86.4395 26.3809V68.2246H86.5537C86.7875 69.3736 87.8125 70.198 89.0117 70.1982C89.4923 70.1982 89.939 70.0569 90.3193 69.8193C89.695 72.5957 87.2339 74.6641 84.2695 74.6641C83.9842 74.664 83.6983 74.6378 83.4082 74.5977L83.3311 74.5869L83.2549 74.6006C83.0504 74.6359 82.8305 74.6465 82.5859 74.6465H8.44238C6.27526 74.6465 4.5 72.9119 4.5 70.7617V26.3809C4.50021 24.2157 6.29036 22.3945 8.44238 22.3945Z",
    fill: "url(#paint0_linear_1273_1654)",
    stroke: "#92841D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3489 41H22.9409L21.8209 37.704H17.3089L16.1889 41H14.8289L18.7329 29.832H20.4449L24.3489 41ZM21.4849 36.52L19.5969 31.08H19.5169L17.6289 36.52H21.4849ZM26.0709 44.2V32.744H27.3509V34.088H27.4149C27.8469 33.048 28.6949 32.552 29.8309 32.552C31.8949 32.552 33.1909 34.232 33.1909 36.872C33.1909 39.512 31.8949 41.192 29.8309 41.192C28.6949 41.192 27.9109 40.68 27.4149 39.656H27.3509V44.2H26.0709ZM29.4789 40.04C30.9189 40.04 31.8149 39.048 31.8149 37.576V36.168C31.8149 34.696 30.9189 33.704 29.4789 33.704C28.3109 33.704 27.3509 34.376 27.3509 35.288V38.36C27.3509 39.432 28.3109 40.04 29.4789 40.04ZM35.3522 44.2V32.744H36.6322V34.088H36.6962C37.1282 33.048 37.9762 32.552 39.1122 32.552C41.1762 32.552 42.4722 34.232 42.4722 36.872C42.4722 39.512 41.1762 41.192 39.1122 41.192C37.9762 41.192 37.1922 40.68 36.6962 39.656H36.6322V44.2H35.3522ZM38.7602 40.04C40.2002 40.04 41.0962 39.048 41.0962 37.576V36.168C41.0962 34.696 40.2002 33.704 38.7602 33.704C37.5922 33.704 36.6322 34.376 36.6322 35.288V38.36C36.6322 39.432 37.5922 40.04 38.7602 40.04ZM45.9134 41H44.6334V32.744H45.9134V34.264H45.9934C46.2814 33.48 47.0334 32.744 48.3774 32.744H48.8734V34.024H48.1214C46.7454 34.024 45.9134 34.616 45.9134 35.4V41ZM53.5503 41.192C51.3423 41.192 49.8223 39.496 49.8223 36.872C49.8223 34.248 51.3423 32.552 53.5503 32.552C55.7583 32.552 57.2783 34.248 57.2783 36.872C57.2783 39.496 55.7583 41.192 53.5503 41.192ZM53.5503 40.056C54.9263 40.056 55.9023 39.208 55.9023 37.464V36.28C55.9023 34.536 54.9263 33.688 53.5503 33.688C52.1743 33.688 51.1983 34.536 51.1983 36.28V37.464C51.1983 39.208 52.1743 40.056 53.5503 40.056ZM62.5704 41H61.0824L58.1864 32.744H59.4664L60.9064 36.84L61.8024 39.656H61.8824L62.7784 36.84L64.2504 32.744H65.4824L62.5704 41ZM73.7128 41H72.9928C72.0488 41 71.6648 40.424 71.5688 39.656H71.4888C71.1368 40.664 70.2568 41.192 69.1048 41.192C67.3608 41.192 66.3368 40.232 66.3368 38.696C66.3368 37.144 67.4568 36.28 69.8568 36.28H71.4888V35.464C71.4888 34.296 70.8488 33.656 69.5368 33.656C68.5448 33.656 67.8888 34.136 67.4408 34.888L66.6728 34.168C67.1208 33.288 68.1128 32.552 69.6008 32.552C71.5848 32.552 72.7688 33.592 72.7688 35.336V39.88H73.7128V41ZM69.3128 40.104C70.5768 40.104 71.4888 39.448 71.4888 38.6V37.24H69.7928C68.3368 37.24 67.6808 37.688 67.6808 38.488V38.824C67.6808 39.64 68.3208 40.104 69.3128 40.104ZM78.0357 41H76.8997C76.0197 41 75.5397 40.44 75.5397 39.672V29.16H76.8197V39.88H78.0357V41Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1273_1654",
    x: 0,
    y: 0,
    width: 95.0215,
    height: 83.1641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1273_1654"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1273_1654",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1273_1654",
    x1: 47.4874,
    y1: 21.8945,
    x2: 47.4874,
    y2: 75.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalFolder);
export default __webpack_public_path__ + "static/media/Approval_folder.7e77bfba2059bc6997b94fb56f9bed93.svg";
export { ForwardRef as ReactComponent };